<template>
  <div class="medicine">
    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <h3>Inteligência Artificial</h3>
        <h4>Pixeon Lumia</h4>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <figure>
          <img
            class="icon"
            alt="Vue logo"
            src="https://firebasestorage.googleapis.com/v0/b/pixeon-c-admin.appspot.com/o/solutions%2Fia%2Fia1.png?alt=media&token=4cc7fd72-64b1-4bb5-b6d9-50b718bb99de"
          />
        </figure>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <p>
          TA Pixeon Lumia alia inteligência e <strong>agilidade</strong> a <strong>processos humanizados</strong>
          e está à disposição do <strong>paciente</strong> em todas as fases da sua jornada.
        </p>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <h5>Plataforma de inteligência artificial</h5>
        <figure>
          <img
            class="icon"
            alt="Vue logo"
            src="https://firebasestorage.googleapis.com/v0/b/pixeon-c-admin.appspot.com/o/solutions%2Fia%2Fia2.png?alt=media&token=f3152fd5-21c7-4166-ab60-e4229fd2c3ad"
          />
        </figure>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <figure>
          <img
            class="big-picture"
            alt="Vue logo"
            :src="data.ia.img1"
          />
        </figure>
      </el-col>
    </el-row>
    <div class="close-btn-text mt-5 mb-5" @click="$emit('close-service')">Fechar</div>
  </div>
</template>

<script>
export default {
  name: 'ia',
  props: ['data']
}
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";

.medicine-titles {
  text-transform: uppercase;

  h3 {
    font-weight: bold;
    color: $purple;
    max-width: 60%;
    font-size: 3rem;
    line-height: 4rem;
  }

  h4 {
    font-size: 3rem;
    line-height: 4rem;
    color: $purple;
    font-weight: 300;
  }

  h5 {
    font-weight: bold;
    font-size: 1.8rem;

    line-height: 4rem;
    color: $purple;
    font-weight: 300;
  }

  p {
    padding-top: 2rem;
    text-transform: none;
    width: 60%;
  }
}

.big-picture {
  width: 100%;
}
</style>
